<template>
    <form-input-number
        v-model="displayValue"
        v-bind="$attrs"
        :precision="precision"
    >
        <template slot="append">
            <select
                v-if="currencySelect"
                v-model="currencyInputValue"
                @change="$emit('update:currency', currencyInputValue)"
                :name="currencyName"
                class="custom-select flex-basis-auto flex-grow-0 w-auto"
            >
                <option
                    v-for="currency in currencies"
                    :value="currency.value"
                    :key="`currency-${currency.value}`"
                >
                    {{ currency[currencySelectDisplayKey] }}
                </option>
            </select>
            <div
                v-else
                class="input-group-append"
            >
                <span class="input-group-text">
                    {{ activeCurrency[currencyDisplayKey] }}
                </span>
            </div>
        </template>
        <input
            v-if="name"
            :name="name"
            :value="valueInCents"
            type="hidden"
        >
    </form-input-number>
</template>

<script>
    import Config from '../../config';
    import FormInputNumber from '../form-input-number';

    export default {
        name: 'FormInputMoney',
        inheritAttrs: false,
        components: {
            FormInputNumber,
        },
        props: {
            value: {
                type: [String, Number],
                default: null,
            },
            name: {
                type: String,
                default: null,
            },
            precision: {
                type: Number,
                default: Config.options.precision,
            },
            currency: {
                type: String,
                default: Config.options.currency,
            },
            currencies: {
                type: Array,
                default: () => Config.options.currencies,
            },
            currencySelect: {
                type: Boolean,
                default: false,
            },
            currencyName: {
                type: String,
                default: 'currency',
            },
            currencyDisplayKey: {
                type: String,
                default: Config.options.currencyDisplayKey,
            },
            currencySelectDisplayKey: {
                type: String,
                default: Config.options.currencySelectDisplayKey,
            },
        },
        data() {
            return {
                valueInCents: null,
                currencyInputValue: null,
            };
        },
        computed: {
            displayValue: {
                get() {
                    if (!this.valueInCents && this.valueInCents !== 0) return '';

                    return this.valueInCents / 100;
                },
                set(value) {
                    if (value === '') {
                        this.valueInCents = null;
                        return;
                    }

                    const precisionForCents = Math.max(0, this.precision - 2);

                    this.valueInCents = (value * 100).toFixed(precisionForCents);
                },
            },

            activeCurrency() {
                return this.currencies.find(({ value }) => (
                    value === this.currencyInputValue
                ));
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.valueInCents = value;
                },
            },
            currency: {
                immediate: true,
                handler(value) {
                    this.currencyInputValue = value;
                },
            },
        },
    };
</script>
